<!--
 * @Author: your name
 * @Date: 2021-05-25 17:16:46
 * @LastEditTime: 2021-09-08 16:58:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-mall\components\common\header.vue
-->
<template>
  <div class="header_top">
    <div class="top_content flex-sb">
      <div class="top_content_left my_dropdown">
        <div class="unlogin" v-show="!isLogin">
          <!-- <span>您好，请</span> -->
          <span
            class="login-txt pointer"
            style="margin-right:25px"
 
            >登录</span
          >
          <span style="position: relative;"><i class="separate-i2"></i></span>
          <span class="login-txt pointer" >注册</span>
        </div>
      </div>
      
     
       <div class="top_content_right my_dropdown flex">
        <!-- 中文站 -->
        <eChinese :menuListData="siteList"></eChinese>
 
         <i class="separate-i" style="margin-left:0;"></i>
         <img class="service_language" src="../../../../assets/img/service.png" alt="">
         <div class="my-menu-hover" >
           <span>在线客服</span>
         </div>
         <i class="separate-i" style="margin-right:0;"></i>
         <!-- 联系客服 -->
         <eService :menuListData="servicePhoneData"></eService>
       </div>
        
      </div>



    
    </div>
   
 
</template>
<script>
import {YPKphone,YPKcall,siteList,servicePhoneData} from "../../utils/globalData";
import eChinese from "./e-chinese.vue";
import eService from "./e-service.vue";
export default {
  data() {
    return {
      YPKphone,
      YPKcall,
 
 
      siteList,
      servicePhoneData,
      activeIndex: "",
      userInfo: {},
      // double_identity 双重身份  supplier  供应商  purchase  采购商
      isLogin: false,
      menuListData: [],
      websiteNav: [],
 
      companyList: [],
  
    };
  },
  components: {
 
 
 
    eChinese,
    eService
  },
  created() {
     
    
  },
  
  
  mounted() {
     
    
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
.header_top {
  width: 100%;
  height: 30px;
  background: #163b6d;

  .top_content {
    width: 1200px;
    margin: 0 auto;
    line-height: 30px;
    font-size: 12px;

    .site_kefu {
      color: #2587ff;
      font-size: 16px;
      cursor: pointer;
    }

    .menu_item {
      color: #fff;
      cursor: pointer;
      position: relative;
      z-index: 200;

      .menu_name {
        padding: 0 10px;
      }
    }

    .menu_item_active {
      color: #333;
      background: #fff;
    }

    .menu_content {
      width: 260px;
      min-height: 116px;
      background: #fff;
      position: absolute;
      z-index: 100;
      top: 30px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      padding: 10px 20px 20px 20px;
      display: flex;

      .user_logo {
        img {
          width: 35px;
          height: 35px;
        }
      }
      .company_name{
        width: 144px;
        color:#666;
        font-size:12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .company_name:hover{
        white-space: normal !important;
        height: auto !important;
        word-wrap: break-word !important;
        word-break: break-all !important;
        overflow: hidden !important;
      }
      .user_info {
        flex: 1;
        margin-left: 10px;

        // p {
        //   height: 24px;
        //   line-height: 24px;
        // }

        p img {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }

        .change_btn {
          // height: 30px;
          // line-height: 30px;
          color: #0064c8;
          cursor: pointer;
          line-height: normal;
        }
        .change_btn:hover{
          border-bottom: 1px solid #0064c8;
        }

        .account {
          display: flex;
          height: 30px;
          line-height: 30px;
          // margin-top: 30px;
          margin-top: 6px;

          .account_set {
            width: 80px;
            height: 30px;
            line-height: 30px;
            color: #333333;
            text-align: center;
            border: 1px solid #d9d9d9;
            font-size: 12px;
          }

          .account_set:hover {
            color: #0064c8;
            background: #e8efff;
            border: 1px solid #2587ff;
          }

          .loginout {
            line-height: 30px;
            color: #0064c8;
            cursor: pointer;
            .classic {
              margin-top: -5px;
              z-index: 100;
            }
          }

          .loginout:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .menu_content1 {
      background: #fff;
      position: absolute;
      z-index: 100;
      top: 30px;
      width: 100%;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);

      ul li {
        padding-left: 10px;
        line-height: 32px;

        color: #666666;
      }

      ul li:hover {
        color: #ea9200;
      }
    }

    .menu_content2 {
      background: #fff;
      position: absolute;
      z-index: 100;
      top: 30px;
      width: 180px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    }
  }
}

.my_dropdown {
  // height: 30px;
  // align-items: center;
  .service_language {
    widows: 16px;
    height: 15px;
    margin: 7px 6px 0 0;
  }
  .el-dropdown {
    // cursor: pointer;
    color: #fff;
    // margin-right: 24px;
    font-size: 12px;

    ::deep .el-dropdown-link {
      .site_language {
        width: 15px;
        height: 10px;
        // vertical-align: middle;
        margin-top: 3px;
      }

      .site_phone {
        // color: #2587FF;
        color: #fff;
      }
    }
  }
}

.my-menu {
  border: none;
  // background-color:none !important;
  background-color: #163b6d;

  ::deep .el-submenu {
    line-height: 30px;
    height: 30px;

    .el-submenu__title {
      width: 120px;
      line-height: 30px;
      height: 30px;
      color: #fff;
      font-size: 12px;

      i {
        color: #fff;
      }
    }
  }

  ::deep  .el-dropdown-menu {
    border: 2px solid red;
  }

  ::deep  .el-submenu:hover {
    .el-submenu__title {
      line-height: 30px;
      height: 30px;
      color: #fff;
      background-color: #163b6d;
    }
  }

  ::deep .el-menu-item {
    line-height: 30px;
    height: 30px;
    color: #fff;
    background-color: #163b6d;
  }

  ::deep .el-menu-item:hover {
    background-color: #163b6d;
    color: #fff;
  }

  ::deep .el-menu-item.is-active {
    z-index: 9;
    background-color: #163b6d;
    color: #fff;
    border-bottom: none;
  }

  ::deep .el-submenu.is-active .el-submenu__title {
    z-index: 9;
    border-bottom: none;
  }
}

.unlogin {
  width: 80px;
  font-size: 12px;
  color: #fff;
  .login-txt {
    // color: #FF5B27;
    cursor: pointer;

    &:hover {
      color: #78d7ff;
      border-bottom: 1px solid #78d7ff;
    }
  }
}

.login-status {
  display: flex;

  .login-txt {
    position: relative;
    color: #fff;
    font-size: 12px;
    margin-right: 10px;

    .icon-arrow {
      width: 8px;
      height: 5px;
    }
  }

  .userInfo {
    z-index: 1000;
    width: 315px;
    position: absolute;
    background: #fff;
  }
}

.company-list {
  ul {
    li {
      padding: 0 20px;
      border-bottom: 1px solid #d9d9d9;
      display: flex;
      height: 50px;
      align-items: center;
      justify-content: space-between;

      div {
        img {
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }

        display: flex;
      }

      & > span {
        color: #0064c8;
        font-size: 14px;

        &.active {
          border-bottom: 1px solid #0064c8;
        }
      }
    }
  }
}
.separate-i {
  height: 12px;
  width: 1px;
  display: inline-block;
  background: #a2b1c5;
  margin: auto 12px;
}
.separate-i2 {
  height: 12px;
  width: 1px;
  display: inline-block;
  background: #a2b1c5;
  position: absolute;
  top: 0;
  right: 13px;
}
.my-menu-person {
  color: #fff;
  p {
    cursor: pointer;
  }
}
.my-menu-hover {
  color: #fff;
  font-size: 12px;
  ::deep  .el-badge{
    height: 100%;
    vertical-align: inherit !important;
  }
  ::deep  .el-badge__content.is-fixed.is-dot{
    right: 1px;
    top: 8px;
    background: #F0250F;
  }
  span {
    cursor: pointer;
  }
  span:hover {
    color: #78d7ff;
    border-bottom: 1px solid #78d7ff;
  }
}
 
</style>


